<div class="osm-map-wrapper">

  <div class="osm-map" [ngStyle]="style" #osmMap>

  </div>

  <ng-content></ng-content>
</div>
